var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ToolbarWithBackAndDisableEditButtons } from '../common/Toolbar';
import ArticleContent from './ArticleContent';
import VideoContent from './VideoContent';
import { Body } from '../root/PageRouter';
export default function ContentDetails(props) {
    var canUpdate = (props.isOwner && props.isPoster) || props.isModerator;
    var disabled = !canUpdate;
    var isArticle = props.type === 'ARTICLE';
    var title = isArticle ? 'Article' : 'Video';
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithBackAndDisableEditButtons, __assign({ disabled: disabled, onClick: props.onForwardClick }, { children: title }), void 0),
            _jsx(Body, { children: isArticle ? (_jsx(ArticleContent, { title: props.title, description: props.description, url: props.url }, void 0)) : (_jsx(VideoContent, { contentId: props.contentId, title: props.title, description: props.description, url: props.url, startAt: props.startAt }, void 0)) }, void 0)] }, void 0));
}
//# sourceMappingURL=ContentDetails.js.map